// extracted by mini-css-extract-plugin
export var hideEditor = "_lc-2";
export var infoIcon = "_lc-3";
export var label = "_lc-1";
export var labelContainer = "_lc-0";
export var readonlyText = "_lc-4";